/*
 * Add-to-cart log. theme.js Cart.request calls GTCartLogReport after every
 * successful /cart/add (Add to cart, Buy now, quick add); it is reported to the
 * owner's Google Apps Script, which appends a row to the "GomlaTech cart log" sheet.
 * Config comes from layout/theme.liquid (window.GTCartLog). Never blocks or
 * alters the cart request: reporting runs after the response and fails silently.
 */
(function () {
  var cfg = window.GTCartLog;
  if (!cfg || !cfg.url || !window.fetch) return;

  function visitorId() {
    var key = 'gt:visitor';
    try {
      var v = localStorage.getItem(key);
      if (!v) {
        v = 'V-' + Math.random().toString(36).slice(2, 8).toUpperCase();
        localStorage.setItem(key, v);
      }
      return v;
    } catch (e) {
      return 'V-unknown';
    }
  }

  function requestedQty(body) {
    // Map variant id -> quantity from the request; /cart/add.js answers with the
    // line's total quantity, which overcounts when the item was already in the cart.
    var map = {};
    try {
      if (typeof body === 'string') {
        var d = JSON.parse(body);
        (d.items || [d]).forEach(function (i) { if (i && i.id) map[String(i.id)] = Number(i.quantity) || 1; });
      } else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) map[String(body.get('id'))] = Number(body.get('quantity')) || 1;
      }
    } catch (e) {}
    return map;
  }

  function report(data, qty) {
    var items = (data && (data.items || (data.id ? [data] : []))) || [];
    if (!items.length) return;
    var c = cfg.customer || {};
    var payload = {
      type: 'cart',
      key: cfg.key || window.GTMailerKey || '',
      site: location.hostname,
      alertMin: Number(cfg.alertMin) || 0,
      visitor: visitorId(),
      customer: c.name || '',
      email: c.email || '',
      phone: c.phone || '',
      orders: c.orders == null ? '' : c.orders,
      page: location.pathname,
      referrer: document.referrer ? document.referrer.replace(/^https?:\/\//, '').split('/')[0] : '',
      device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
      language: cfg.locale || '',
      items: items.map(function (i) {
        var q = qty[String(i.variant_id || i.id)] || Number(i.quantity) || 1;
        return {
          product: i.product_title || i.title || '',
          variant: i.variant_title || '',
          sku: i.sku || '',
          qty: q,
          price: (Number(i.final_price != null ? i.final_price : i.price) || 0) / 100,
          url: i.url ? location.origin + i.url.split('?')[0] : ''
        };
      })
    };
    try {
      fetch(cfg.url, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  // Called by Cart.request in theme.js after a successful /cart/add. (Wrapping
  // window.fetch does not work here: a store app keeps its own copy of fetch.)
  window.GTCartLogReport = function (data, body) {
    try { report(data, requestedQty(typeof body === 'string' ? body : JSON.stringify(body || {}))); } catch (e) {}
  };
})();
